import type { DraftScratchpad } from './types.js';

// WHY (#599): aggregates surface "Positions + Boxes" totals per the
//   issue acceptance criterion. A box's contribution is `count *
//   weightKg` (weight) and `count * volumeM3` (volume) — the same
//   shape the backend uses for filter-aggregate match (UNION ALL
//   in `request-aggregate-filter.ts`).
export function computeDraftAggregates(d: DraftScratchpad): {
  aggWeight: number | null;
  aggVolume: number | null;
} {
  const aggItemWeight = d.items.reduce((s, it) => s + (it.weight || 0), 0);
  const aggItemVolume = d.items.reduce((s, it) => s + (it.volume || 0), 0);
  const aggBoxWeight = d.boxes.reduce((s, b) => s + (b.weightKg || 0) * (b.count || 0), 0);
  const aggBoxVolume = d.boxes.reduce((s, b) => s + (b.volumeM3 || 0) * (b.count || 0), 0);
  return {
    aggWeight: aggItemWeight + aggBoxWeight || null,
    aggVolume: aggItemVolume + aggBoxVolume || null,
  };
}
